import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { LesPreparationOverTab } from "#/modules/les.planning/components/les-preparation-over-tab";
import {
  preparationBeforeLoad,
  preparationLayoutOptions,
} from "#/modules/les.planning/preparation-routes";
import { startLessonFlowSearchDefaults } from "#/modules/les.start-flow/filters";

// The les is edited over this tab of its page, which stays as it is underneath.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lesson/$lesson/teacher/sport-participation/les",
)({
  ...preparationLayoutOptions,
  search: { middlewares: [stripSearchParams(startLessonFlowSearchDefaults)] },
  beforeLoad: ({ search, params, location, context }) =>
    preparationBeforeLoad("sport-participation", { search, params, location, context }),
  component: Preparation,
});

function Preparation() {
  const params = Route.useParams();
  const navigate = Route.useNavigate();
  return (
    <LesPreparationOverTab
      tab="sport-participation"
      params={params}
      search={Route.useSearch()}
      klassen={Route.useLoaderData().klassen}
      onClose={() =>
        navigate({
          to: "/$locale/{-$schoolyear}/$school/lesson/$lesson/teacher/sport-participation",
          params,
          search: {},
          replace: true,
          resetScroll: false,
          viewTransition: true,
        })
      }
    />
  );
}
